import type { IconType } from 'react-icons';
import { TbCode, TbFileDescription, TbId, TbSettings, TbUserCode } from 'react-icons/tb';

export type OAuthApplicationFormSectionKey = 'metadata' | 'publicDetails' | 'developer' | 'settings' | 'scopes';

export interface OAuthApplicationCreationStep {
    icon: IconType;
    id: string;
    key: OAuthApplicationFormSectionKey;
    label: string;
}

export const oauthApplicationCreationSteps: OAuthApplicationCreationStep[] = [
    {
        key: 'metadata',
        id: 'oauth-application-metadata',
        icon: TbId,
        label: 'Application Metadata',
    },
    {
        key: 'publicDetails',
        id: 'oauth-application-public-details',
        icon: TbFileDescription,
        label: 'Public Integration Details',
    },
    {
        key: 'developer',
        id: 'oauth-application-developer',
        icon: TbUserCode,
        label: 'Developer Information',
    },
    {
        key: 'settings',
        id: 'oauth-application-settings',
        icon: TbSettings,
        label: 'OAuth 2.0 Settings',
    },
    {
        key: 'scopes',
        id: 'oauth-application-scopes',
        icon: TbCode,
        label: 'Scopes',
    },
];

export const oauthApplicationCreationStepsByKey = Object.fromEntries(
    oauthApplicationCreationSteps.map((step) => [step.key, step]),
) as Record<OAuthApplicationFormSectionKey, OAuthApplicationCreationStep>;
